import React from 'react';
import { cn } from '@shared/utils/utils'; // O ajusta según tu path del helper de clases

interface SectionBoxProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

export const SectionBox: React.FC<SectionBoxProps> = ({
  title,
  children,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <section
      className={cn(
        'rounded-lg border border-card-border p-4 md:p-4 space-y-4',
        className
      )}
      data-testid={dataTestId}
    >
      {title && <h2 className="text-lg font-normal">{title}</h2>}
      <div className="h-full">{children}</div>
    </section>
  );
};
